import { render, staticRenderFns } from "./RouteManagement.vue?vue&type=template&id=3448fde5&scoped=true&"
import script from "./RouteManagement.vue?vue&type=script&lang=ts&"
export * from "./RouteManagement.vue?vue&type=script&lang=ts&"
import style0 from "./RouteManagement.vue?vue&type=style&index=0&id=3448fde5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3448fde5",
  null
  
)

export default component.exports